import React, { useState } from 'react';

const faqs = [
  {
    question: 'Wat is een NDA in België?',
    answer: 'Een NDA (Non-Disclosure Agreement) of geheimhoudingsovereenkomst is een juridisch bindend contract waarbij partijen afspreken om vertrouwelijke informatie niet te delen met derden. In België wordt de bescherming van bedrijfsgeheimen geregeld door de Wet van 30 juli 2018. Als Belgische freelancer of zelfstandige gebruik je een NDA om de vertrouwelijke informatie van jouw opdrachtgevers te beschermen en jouw eigen aansprakelijkheid te beperken.',
  },
  {
    question: 'Wanneer heb je een NDA nodig als freelancer in België?',
    answer: 'Als Belgische zelfstandige of freelancer heb je een NDA nodig wanneer je toegang krijgt tot gevoelige bedrijfsinformatie van een opdrachtgever, zoals bedrijfsstrategieën, klantgegevens, broncode, financiële gegevens of productideeën. Veel Belgische bedrijven eisen een ondertekende NDA voordat ze met een externe freelancer samenwerken. Ook bij het pitchen van eigen ideeën aan potentiële klanten is een NDA aan te raden.',
  },
  {
    question: 'Hoe lang is een NDA geldig in België?',
    answer: 'De geldigheidsduur van een NDA in België wordt bepaald door de partijen zelf en staat vermeld in het contract. Typisch varieert de duur van 2 tot 5 jaar na beëindiging van de samenwerking. Voor informatie die kwalificeert als bedrijfsgeheim conform de Wet van 30 juli 2018 kan de geheimhoudingsplicht onbeperkt gelden zolang de informatie haar vertrouwelijk karakter behoudt.',
  },
  {
    question: 'Wat zijn de gevolgen van schending van een NDA in België?',
    answer: 'Bij schending van een NDA in België kan de benadeelde partij schadevergoeding eisen via de Belgische rechtbank. Een goed opgestelde NDA bevat een boeteclausule (forfaitaire schadevergoeding) die onmiddellijk opeisbaar is bij overtreding. Daarnaast kan de rechter een verbod opleggen om de vertrouwelijke informatie verder te gebruiken of te verspreiden. De Wet van 30 juli 2018 biedt aanvullende bescherming voor bedrijfsgeheimen.',
  },
  {
    question: 'Kan ik een gratis NDA template gebruiken als Belgische freelancer?',
    answer: 'Ja, via Pactorae kun je gratis een professionele NDA genereren die is afgestemd op het Belgisch recht. De generator vraagt naar jouw ondernemingsnummer en btw-nummer voor correcte identificatie, en past de clausules aan op de Belgische wetgeving. Het resulterende document is juridisch correct en direct bruikbaar voor jouw freelance opdrachten in België.',
  },
];

const FaqItem = ({ faq }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-gray-200 rounded-xl bg-white shadow-sm overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-6 py-5 text-left focus:outline-none"
        aria-expanded={open}
      >
        <span className="text-base font-semibold text-[#2F4E6F] pr-4">{faq?.question}</span>
        <span
          className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-transform duration-200"
          style={{ backgroundColor: '#FF8C00', transform: open ? 'rotate(45deg)' : 'rotate(0deg)' }}
        >
          <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 4v16m8-8H4" />
          </svg>
        </span>
      </button>
      {open && (
        <div className="px-6 pb-5">
          <p className="text-gray-600 leading-relaxed">{faq?.answer}</p>
        </div>
      )}
    </div>
  );
};

const NdaBelgiumFaq = () => (
  <section className="mb-12">
    <h2 className="text-2xl font-bold text-[#2F4E6F] mb-6">Veelgestelde vragen over NDA's in België</h2>
    <div className="space-y-4">
      {faqs?.map((faq, i) => (
        <FaqItem key={i} faq={faq} />
      ))}
    </div>
  </section>
);

export default NdaBelgiumFaq;
export { faqs };
